import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class CartPricingLineResponse
*  
*/
export class CartPricingLineResponse extends ActiveModel {

  /**
  * productId
  *   */
  @ActiveField()
  productId?: number


  /**
  * baseLineTotal
  *   */
  @ActiveField()
  baseLineTotal?: number


  /**
  * discountTotal
  *   */
  @ActiveField()
  discountTotal?: number


  /**
  * finalLineTotal
  *   */
  @ActiveField()
  finalLineTotal?: number


  /**
  * pointsEligible
  *   */
  @ActiveField()
  pointsEligible?: boolean
}
